import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelText as _vModelText, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sechzig-plus-info"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Steps = _resolveComponent("Steps")!
  const _component_ueberschrift = _resolveComponent("ueberschrift")!
  const _component_titel_zelle = _resolveComponent("titel-zelle")!
  const _component_validierungs_fehler = _resolveComponent("validierungs-fehler")!
  const _component_zelle = _resolveComponent("zelle")!
  const _component_zeile = _resolveComponent("zeile")!
  const _component_adresse = _resolveComponent("adresse")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Steps, {
      items: _ctx.navItems,
      active: 0
    }, null, 8, ["items"]),
    _createElementVNode("section", null, [
      (!_ctx.piniaStore.state.isMakler)
        ? (_openBlock(), _createBlock(_component_ueberschrift, {
            key: 0,
            titel: "Ihre Angaben"
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_zeile, null, {
        default: _withCtx(() => [
          _createVNode(_component_titel_zelle, null, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [
              _createElementVNode("strong", null, "Wen", -1),
              _createTextVNode(" möchten Sie versichern?")
            ])),
            _: 1,
            __: [10]
          }),
          _createVNode(_component_zelle, { class: "iconRadioPHV" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                id: "tarifVariante1",
                name: "tarifVariante",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.piniaStore.state.tarifinformationen.tarifVariante) = $event)),
                type: "radio",
                value: "991",
                required: "",
                "data-fehlermeldung": "Bitte wählen Sie den zu versichernden Personenkreis aus.",
                "data-cy": "tarifVariante1",
                tabindex: "0",
                autofocus: "",
                class: "no-outline",
                "aria-required": "true",
                "aria-label": "Single"
              }, null, 512), [
                [_vModelRadio, _ctx.piniaStore.state.tarifinformationen.tarifVariante]
              ]),
              _withDirectives(_createElementVNode("input", {
                id: "tarifVariante2",
                name: "tarifVariante",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.piniaStore.state.tarifinformationen.tarifVariante) = $event)),
                type: "radio",
                value: "992",
                "data-cy": "tarifVariante2",
                class: "no-outline",
                "aria-label": "Single mit Kind oder Kindern"
              }, null, 512), [
                [_vModelRadio, _ctx.piniaStore.state.tarifinformationen.tarifVariante]
              ]),
              _withDirectives(_createElementVNode("input", {
                id: "tarifVariante3",
                name: "tarifVariante",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.piniaStore.state.tarifinformationen.tarifVariante) = $event)),
                type: "radio",
                value: "993",
                "data-cy": "tarifVariante3",
                class: "no-outline",
                "aria-label": "Paar ohne Kinder"
              }, null, 512), [
                [_vModelRadio, _ctx.piniaStore.state.tarifinformationen.tarifVariante]
              ]),
              _withDirectives(_createElementVNode("input", {
                id: "tarifVariante4",
                name: "tarifVariante",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.piniaStore.state.tarifinformationen.tarifVariante) = $event)),
                type: "radio",
                value: "994",
                "data-cy": "tarifVariante4",
                class: "no-outline",
                "aria-label": "Paar mit Kind oder Kindern"
              }, null, 512), [
                [_vModelRadio, _ctx.piniaStore.state.tarifinformationen.tarifVariante]
              ]),
              _createVNode(_component_validierungs_fehler, {
                "fehler-text": _ctx.fehler.tarifVariante,
                "reduzierter-abstand": true
              }, null, 8, ["fehler-text"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_zeile, null, {
        default: _withCtx(() => [
          _createVNode(_component_titel_zelle, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(!_ctx.piniaStore.state.isMakler ? "Ihr " : "") + " Geburtsdatum", 1)
            ]),
            _: 1
          }),
          _createVNode(_component_zelle, { breite: 6 }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                style: {"width":"50%"},
                type: "date",
                id: "geburtsdatum",
                name: "geburtsdatum",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.geburtsdatum) = $event)),
                class: "c-form-control__input",
                placeholder: "TT.MM.JJJJ",
                title: "Geburtsdatum im Format TT.MM.JJJJ",
                required: "",
                "aria-required": "true",
                "aria-label": "Geben Sie Ihr Geburtsdatum in der Formatierung TT.MM.JJJJ ein.",
                "data-checkalter18bis100": "true",
                "data-cy": "versicherungsnehmerGeburtstag"
              }, null, 512), [
                [_vModelText, _ctx.piniaStore.state.personendaten.versicherungsnehmer.geburtsdatum]
              ]),
              _createVNode(_component_validierungs_fehler, {
                "fehler-text": _ctx.fehler.geburtsdatum
              }, null, 8, ["fehler-text"]),
              (_ctx.piniaStore.state.isMakler)
                ? (_openBlock(), _createElementBlock("p", _hoisted_1, " Versicherungsnehmer ab 60 Jahren werden in diesem Tarifrechner automatisch dem günstigen 60+ Tarif zugeordnet. "))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_adresse, {
        fehler: _ctx.fehler,
        placeholder: true,
        plz: _ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.plz,
        "onUpdate:plz": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.plz) = $event)),
        ort: _ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.ort,
        "onUpdate:ort": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.ort) = $event)),
        strasse: _ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.strasse,
        "onUpdate:strasse": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.strasse) = $event)),
        hausnummer: _ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.hausnummer,
        "onUpdate:hausnummer": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.hausnummer) = $event)),
        feldNamen: {
        plz: 'versicherungsnehmerPlz',
        ort: 'versicherungsnehmerOrt',
        strasse: 'versicherungsnehmerStrasse',
        hausnummer: 'versicherungsnehmerHausnummer',
      },
        "sichtbare-felder": ['plz'],
        "clear-ort-on-plz-focus": true,
        ref: "risikoAdresseRef",
        "zeige-info": true,
        "info-text": _ctx.adresseInfotext
      }, {
        plzOrtLabel: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.plzZelleTitel), 1)
        ]),
        _: 1
      }, 8, ["fehler", "plz", "ort", "strasse", "hausnummer", "info-text"]),
      _createVNode(_component_zeile, null, {
        default: _withCtx(() => [
          _createVNode(_component_zelle, {
            breite: 3,
            offset: 4
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                class: "c-button c-button--full-width u-mar-t-2 u-mar-b-2 mobil-mehrAbstand",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
                "data-cy": "submitZumVergleich",
                "aria-label": "Weiter zum Vergleich"
              }, " Weiter zum Vergleich ")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ], 64))
}